export const SUPPLIER_SALES_STATISTICS_DATA = 'SUPPLIER_SALES_STATISTICS_DATA';
export const SUPPLIER_SALES_STATISTICS_DETAIL_DATA = 'SUPPLIER_SALES_STATISTICS_DETAIL_DATA';
